import { render, staticRenderFns } from "./LectureEntityDetails.vue?vue&type=template&id=840db89e&scoped=true"
import script from "./LectureEntityDetails.vue?vue&type=script&lang=js"
export * from "./LectureEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LectureEntityDetails.vue?vue&type=style&index=0&id=840db89e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840db89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('840db89e')) {
      api.createRecord('840db89e', component.options)
    } else {
      api.reload('840db89e', component.options)
    }
    module.hot.accept("./LectureEntityDetails.vue?vue&type=template&id=840db89e&scoped=true", function () {
      api.rerender('840db89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LectureEntityDetails.vue"
export default component.exports